import {Product} from '../models/Product';
export const LOAD_WINDOWS = 'LOAD_WINDOWS';
export const LOAD_WINDOWS_SUCCESS = 'LOAD_WINDOWS_SUCCESS';
export const FETCH_WINDOWS_FAILED = 'FETCH_WINDOWS_FAILED';

export class LoadWindowsAction {
  readonly type = LOAD_WINDOWS;
}

export class LoadWindowsSuccessAction {
  readonly type = LOAD_WINDOWS_SUCCESS;
  constructor(public payload: Product[]) { }
}

export class LoadWINDOWSFailedAction {
  readonly type = FETCH_WINDOWS_FAILED;
}

export type WindowAction = LoadWindowsAction | LoadWindowsSuccessAction | LoadWINDOWSFailedAction;



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/actions/windows.actions.ts